function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  width: 22.5,
  height: 3,
  rx: 1.5,
  fill: "#A6BFCC"
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  y: 7.5,
  width: 22.5,
  height: 3,
  rx: 1.5,
  fill: "#A6BFCC"
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  y: 15,
  width: 22.5,
  height: 3,
  rx: 1.5,
  fill: "#A6BFCC"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.1406 6.21484L32.8906 1.71484L36.6406 6.21484L32.8906 3.21484L29.1406 6.21484Z",
  fill: "#A6BFCC",
  stroke: "#A6BFCC",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M36.6406 11.7852L32.8906 16.2852L29.1406 11.7852L32.8906 14.7852L36.6406 11.7852Z",
  fill: "#A6BFCC",
  stroke: "#A6BFCC",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M32.8906 2.25V15.75",
  stroke: "#A6BFCC",
  strokeWidth: 2
});

var SvgMoveMe = function SvgMoveMe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 38,
    height: 18,
    viewBox: "0 0 38 18",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMoveMe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/move-me.6778b8c3.svg";
export { ForwardRef as ReactComponent };